/**
 *
 * DivisionsImport
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Link } from "react-router-dom"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import ImportScreen from "components/ImportScreen"
import EmptyButton from "components/EmptyButton"
import makeSelectDivisionsImport, {
  makeSelectIsDownloading,
  makeSelectIsUploading,
} from "./selectors"
import reducer from "./reducer"
import saga from "./saga"

import { getTemplateDivision, uploadTemplate } from "./actions"

import emptySvg from "../../images/empty.svg"
import { LeftOutlined } from "@ant-design/icons"
import { LOCAL_USER_ID } from "../../utils/storage"
import { buttonAction_s } from "../../components/Snowplow/config2"
/* eslint-disable react/prefer-stateless-function */
export class DivisionsImport extends React.Component {
  state = { file: null }

  fileSelectedHandler = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])

    this.props.uploadTemplate(fd)
    this.fileInput.value = ""

    // snowplow
    let data_button = {
      category: window.location.hash
        ? window.location.hash
        : window.location.pathname,
      action: `Importar divisiones`,
      label: `boton Importar divisiones`,
      property: "button",
      value: LOCAL_USER_ID(),
    }
    buttonAction_s(data_button)
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Organización - Divisiones</title>
          <meta name="description" content="Description of DivisionsImport" />
        </Helmet>
        <div style={{ padding: "32px 64px" }}>
          <Link
            style={{
              display: "flex",
              alignItems: "center",
            }}
            to="/organization/divisions">
            <LeftOutlined /> Divisiones
          </Link>
        </div>
        <ImportScreen
          title="Crea tus divisiones"
          image={emptySvg}
          description={`
            Crea las divisiones de tu organización a las cuales pertenecen tus
            colaboradores.
            <br />
            Una <span>división</span> agrupa a
            los colaboradores en una unidad organizacional (áreas).
          `}
          secondPoint="Llena los campos con las divisiones de tu empresa, y las divisiones a las que estas reportan."
          thirdPoint="Importa el Excel con la información de las divisiones.">
          <EmptyButton
            size="large"
            label="Descargar plantilla"
            loading={this.props.isDownloading}
            onClick={() => this.props.getTemplate(true)}
          />

          <EmptyButton
            size="large"
            onClick={() => this.fileInput.click()}
            loading={this.props.isUploading}
            label="Importar divisiones"
            style={{ marginLeft: "2rem" }}
          />
          <input
            id="import"
            style={{ display: "none" }}
            type="file"
            onChange={this.fileSelectedHandler}
            ref={(fileInput) => (this.fileInput = fileInput)}
          />
        </ImportScreen>
      </React.Fragment>
    )
  }
}

DivisionsImport.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  divisionsImport: makeSelectDivisionsImport(),
  isDownloading: makeSelectIsDownloading(),
  isUploading: makeSelectIsUploading(),
})

function mapDispatchToProps(dispatch) {
  return {
    getTemplate: (params) => dispatch(getTemplateDivision(params)),
    uploadTemplate: (params) => dispatch(uploadTemplate(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "divisionsImport", reducer })
const withSaga = injectSaga({ key: "divisionsImport", saga })

export default compose(withReducer, withSaga, withConnect)(DivisionsImport)
